import styled from 'styled-components'
import { colors } from './_config.styled'

export const SimpleCountdownWrapper = styled.strong`
  display: inline-flex;
`

export const SimpleDateTimeDisplay = styled.span`
  color: ${props => props.danger ? colors.destructive : colors.neutral_secondary} 
`